var DEFAULT_REFRESH_INTERVAL = 3000;
var timeouts = {};
var crtId = 0;

var getInterval = function getInterval(options) {
  var interval = Infinity;

  if (typeof options.refreshInterval === 'boolean') {
    if (options.refreshInterval) interval = DEFAULT_REFRESH_INTERVAL;
  } else if (typeof options.refreshInterval === 'number') {
    interval = options.refreshInterval;
  }

  return interval;
};

var start = function start(options, loadData) {
  var uniqueId = ++crtId;

  var stop = function stop() {
    clearTimeout(timeouts[uniqueId]);
    delete timeouts[uniqueId];
  };

  var interval = getInterval(options);
  if (interval === Infinity) return {
    stop: stop
  };

  var addTimeout = function addTimeout() {
    clearTimeout(timeouts[uniqueId]);
    timeouts[uniqueId] = setTimeout(function () {
      var promise = loadData({
        silent: true
      });
      if (promise && promise.then) promise.then(addTimeout);else addTimeout();
    }, interval);
  };

  addTimeout();
  return {
    stop: stop
  };
};

export default start;